<template>

    <div class="row">


        <b-col cols="12" lg="5">

            <b-card>
                <div class="position-relative table-responsive">
                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th class="align-middle">Navn</th>
                                <th class="align-middle">Min.</th>
                                <th class="align-middle">Max.</th>
                                <th class="text-right align-middle">
                                    <b-button @click="addGroup" variant="outline-success" class="py-7 px-9">
                                        <feather-icon icon="PlusIcon" class="mr-5" />
                                        <span>Tilføj</span>
                                    </b-button>
                                </th>
                            </tr>
                        </thead>
                        <draggable tag="tbody" v-model="collection" class="cursor-move">
                            <tr v-for="(group, key) in collection" :key="'group-' + key">
                                <th>{{group.name}}</th>
                                <th>{{group.min}}</th>
                                <th>{{group.max}}</th>
                                <td class="text-right">
                                    <b-button @click="editGroup(group)" variant="outline-success" class="py-3 px-2 ml-7">
                                        <feather-icon icon="EditIcon" size="16" class="mx-6 my-2" />
                                    </b-button>
                                    <b-button @click="deleteGroup(key)" variant="outline-danger" class="py-3 px-2 ml-7">
                                        <feather-icon icon="TrashIcon" size="16" class="mx-6 my-2" />
                                    </b-button>
                                </td>
                            </tr>
                        </draggable>
                    </table>

                </div>

            </b-card>
        </b-col>
        
        <b-col cols="12" lg="7" v-if="group">

            <b-card title="Gruppe">
                <FormGroup v-model="group.name" label="Navn" rules=""></FormGroup>

                <div class="mb-9">
                    <editor v-model="group.text" :init="editorConfig" api-key="1omqmjmnhfis5mkj5e0mj2rjzh22wjqhi39nq3ala2vq3yvo"></editor>
                </div>

                <div class="row">
                    <b-col cols="12" md="6">
                        <FormGroup v-model="group.min" label="Min. valg" rules=""></FormGroup>
                    </b-col>
                    <b-col cols="12" md="6">
                        <FormGroup v-model="group.max" label="Max. valg" rules=""></FormGroup>
                    </b-col>
                </div>

                <b-button @click="group = null" variant="outline-success" class="pa-9">
                    <feather-icon icon="XIcon" class="mr-5" />
                    <span>Luk gruppe</span>
                </b-button>
            </b-card>

            <b-card>
                <div class="position-relative table-responsive">
                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th class="align-middle">Produkt</th>
                                <th class="align-middle">Forudvalgt</th>
                                <th class="align-middle">Auto antal</th>
                                <th class="align-middle">Prisjustering</th>
                                <th class="text-right align-middle">
                                    <b-button @click="addProduct" variant="outline-success" class="py-7 px-9">
                                        <feather-icon icon="PlusIcon" class="mr-5" />
                                        <span>Tilføj</span>
                                    </b-button>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, key) in group.products" :key="'product-' + key">
                                <td width="370">
                                    <v-select v-model="item.product" :options="products" @input="selectProduct($event, item)" @search="fetchProducts" placeholder="Vælg produkt" :filterable="false" append-to-body>
                                        <template slot="option" slot-scope="option">
                                            <span class="d-block">{{ option.name }}</span>

                                            <small class="pr-7">{{option.price}} kr.</small>
                                            <small class="pr-7">{{option.url}}</small>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <span class="">{{ option.name }}</span>
                                            <small class="pl-7">{{option.price}} kr.</small>
                                        </template>
                                    </v-select>
                                </td>
                                <td>
                                    <b-form-checkbox v-model="item.selected" switch></b-form-checkbox>
                                </td>
                                <td>
                                    <b-form-checkbox v-model="item.autoQuantity" switch></b-form-checkbox>
                                </td>
                                <td width="150">
                                    <b-form-input v-model="item.priceAdjust" />
                                </td>
                                <td class="text-right">
                                    <b-button @click="group.products.splice(key, 1)" variant="outline-danger" class="py-3 px-2 ml-7">
                                        <feather-icon icon="TrashIcon" size="16" class="mx-6 my-2" />
                                    </b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>

            </b-card>

        </b-col>


    </div>


</template>

<script>
    export default {
        components: {  },
        data: () => ({
            products: [],
            group: null,

            product: null,


            editorConfig: {
                height: 200,
                plugins: [
                    'lists link image paste code'
                ],
                toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | code',
                menubar: ""
            }
        }),
        props: {
            value: null,
        },
        computed: {
            id() {
                return this.$route.params.id
            },
            editing() {
                return this.id != "create"
            },
            collection: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                }
            }
        },
        created() {

        },
        mounted() { },
        methods: {
            addGroup() {
                this.collection.push({
                    name: "*Ny gruppe*",
                    text: "",
                    min: 0,
                    max: 0,
                    products: []
                })
            },
            editGroup(group) {
                this.group = group
            },
            deleteGroup(key) {
                this.collection.splice(key, 1)
            },
            addProduct() {
                this.group.products.push({
                    productId: null,
                    product: null,
                    selected: false,
                    autoQuantity: false,
                    priceAdjust: 0,
                })
            },
            selectProduct(e, product) {
                if (e) {
                    product.productId = e.id
                } else {
                    product.productId = null
                }
            },
            fetchProducts(search, loading) {
                if (search != "") {
                    loading(true)

                    this.$http.get("/api/products", {
                        params: {
                            search: search,
                            //exclude: this.editing ? this.id : null
                        }
                    }).then(x => {
                        this.products = x.data
                        loading(false)
                    })
                }
            },
        },
    }
</script>